// extracted by mini-css-extract-plugin
module.exports = {"container":"updateReadyDialog__container___szetw","content":"updateReadyDialog__content___ykBmu","description":"updateReadyDialog__description___2u8Uf"};